import { render } from "./LoaderOverlay.vue?vue&type=template&id=2bad0154&scoped=true"
import script from "./LoaderOverlay.vue?vue&type=script&lang=js"
export * from "./LoaderOverlay.vue?vue&type=script&lang=js"

import "./LoaderOverlay.vue?vue&type=style&index=0&id=2bad0154&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bad0154"]])

export default __exports__